var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-action',_vm._b({on:{"click":function($event){$event.stopPropagation();return _vm.resetPriceHandler.apply(null, arguments)}}},'button-action',Object.assign({}, _vm.$attrs, {loading: _vm.loading, color: 'primary'}),false))}
var staticRenderFns = []

export { render, staticRenderFns }